import { useState } from 'react'
import { useAuth } from 'resources'
import { pathEq } from 'ramda'

export const useLogin = () => {
  const { login, isLogging } = useAuth()
  const [error, setError] = useState(false)

  const handleSubmit = async values => {
    try {
      await login(values)
    } catch (e) {
      if (hasExpiredPassword(e)) {
        setError(AuthErrors.PASSWORD_EXPIRED)
      } else {
        setError(AuthErrors.INVALID_LOGIN)
      }
    }
  }

  return {
    handleSubmit,
    isLogging,
    error,
  }
}

export const AuthErrors = {
  PASSWORD_EXPIRED: 'PASSWORD_EXPIRED',
  INVALID_LOGIN: 'INVALID_LOGIN',
}

export const ErrorMessageTypes = {
  WARNING: 0,
  ERROR: 1,
}

const hasExpiredPassword = pathEq(['graphQLErrors', '0', 'code'], AuthErrors.PASSWORD_EXPIRED)
